import React from 'react';
import { useTranslation, Trans } from "react-i18next";
import i18next from "i18next";

function Footer() {

  const { t } = useTranslation();

  const lang = i18next.language;

  const docs = {
    privacy: `/docs/privacy-policy/privacy-policy_${lang}.pdf`,
    terms: `/docs/terms-of-use/terms-of-use_${lang}.pdf`,
    cookies: `/docs/cookies-policy/cookies-policy_${lang}.pdf`
  };

  return (
    <div className="mt-[100px] xl:mt-[200px] bg-[#1D1D1D]">
      <div className='bg-[#272727]'>
        <div className="xl:w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
          <div className='flex flex-col xl:flex-row gap-y-[35px] xl:gap-y-0 justify-between py-[65px]'>

            <div className='flex flex-col gap-[10px]'>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F26522]'>
                <Trans>{t('footer.1')}:</Trans>
              </p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6]'>
                {t('footer.2')} 208213205
              </p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6]'>
                {t('footer.3')} BG208213205
              </p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6] max-w-[300px]'>
                {t('footer.4')}
              </p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6]'>{t('footer.add.1')}</p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6]'>{t('footer.add.2')}</p>
            </div>

            <div className='flex xl:flex-col gap-[15px] xl:w-[300px]'>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F26522]'>{t('footer.5')}:</p>

              <a href={docs.privacy} target="_blank" rel="noopener noreferrer">
                <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6] hover:font-[500] transition-all'>
                  {t('footer.6')}
                </p>
              </a>
              <a href={docs.cookies} target="_blank" rel="noopener noreferrer">
                <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6] hover:font-[500] transition-all'>
                  {t('footer.cookies')}
                </p>
              </a>
            </div>

            <div className='flex flex-col gap-[15px] xl:max-w-[370px]'>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F26522]'>{t('footer.8')}</p>
              <p className='open-sans text-[14px] xl:text-[16px] font-[300] text-[#F6F6F6] xl:max-w-[595px]'>
                {t('footer.9')}{" "}
                <a href={docs.terms} className='underline font-[400]'>
                  {t('footer.10')}
                </a>
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
